import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import RenderMilestones from '../../../Ticket/components/RenderMileStones';
import Form from '../../../../common/Form';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { closeModalAction } from '../../../../actions/modal';
import RenderRemarksInput from '../../../../components/Inputs/RenderRemarksInput';
import Radio from '../../../../common/Form/Radio';
import { useNavigate } from 'react-router-dom';
import { approveTicketMilestone } from '../../../../actions/service_request';
import { sendToastMessage } from '../../../../actions/toast';

const formName = 'approve_signoff';

const slaStatusOptions = [
    { value: 'WITHIN_SLA', name: 'manual_sla_status', label: 'Within SLA' },
    { value: 'OUTSIDE_SLA', name: 'manual_sla_status', label: 'Outside SLA' },
];

export default function ApproveSignOff({ milestones, org_id, ticket_id, agents }) {
    const [selectedMilestones, setSelectedMilestones] = useState();
    const methods = useForm({ defaultValues: { manual_sla_status: 'WITHIN_SLA' }, mode: 'all' });
    const formButtonLoading = useSelector((state) => state.loading.formButtonLoading);
    const navigate = useNavigate();

    const dispatch = useDispatch();

    const handleSubmit = ({ processed_remark, manual_sla_status }) => {
        const selectedMilestone = milestones.find((milestone) => milestone.id === selectedMilestones);
        if (selectedMilestone && selectedMilestone.is_signoff_locked) {
            dispatch(sendToastMessage({
                message: 'Signoff is locked, please unlock it first',
                status: 'warning'
            }));
            return;
            // dispatch(openCustomModal({
            //     modalComponent: <UnlockSignoff ticketId={ticket_id} milestones={milestones} />,
            //     heading: 'Unlock Signoff',
            //     modalHeight: 'auto',
            //     modalWidth: '40rem'
            // }));
        }
        let p = {};
        if (processed_remark?.value) {
            p.accepted_remark = processed_remark.label;
            if (!processed_remark.value.startsWith('create_this_issue')) {
                p.master_remark_id = processed_remark.value;
            }
        }
        if (manual_sla_status) {
            p.manual_sla_status = manual_sla_status;
        }
        dispatch(approveTicketMilestone({
            payload: p,
            formName,
            ticketId: ticket_id,
            milestoneId: selectedMilestones,
            onSuccess: () => navigate(-1)
        }))
    }
    return <div className="px-6 py-4 relative overflow-hidden">
        <RenderMilestones milestones={milestones} selectedMilestones={selectedMilestones} setSelectedMilestones={setSelectedMilestones} agents={agents} />
        <div className='w-full pt-2'>
            <Form
                className='w-full'
                methods={methods}
                onSubmit={handleSubmit}
                showSubmit
                isLoading={formButtonLoading[formName]}
                onCancel={() => dispatch(closeModalAction())}
                submitContainerClassName='flex gap-2 justify-end py-4 px-4 relative'
            >
                <div className='w-full space-y-4'>
                    <div className='bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg p-4 border border-blue-200 flex items-center'>
                        <label className='block text-md font-semibold text-gray-700'>
                            Manual SLA Status:
                        </label>
                        <Radio
                            className='flex flex-row gap-4 items-center'
                            name='manual_sla_status'
                            id='manual_sla_status'
                            options={slaStatusOptions}
                        />
                    </div>
                    <RenderRemarksInput
                        category={"APPROVAL"}
                        org_id={org_id}
                        name='processed_remark'
                        label='Remark'
                        className='w-full focus:ring-2 focus:ring-primary/20 transition-all duration-300'
                    />
                </div>
            </Form>
        </div>
    </div>
}